import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 text-lg font-heading font-bold leading-none">K</span>
              </div>
              <span className="text-background-50 font-heading text-lg font-semibold whitespace-nowrap">
                Kakobuy <span className="text-primary-400">Polska</span>
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              Kategorie
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                >
                  {cat.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">
              Przydatne Linki
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Strona Główna
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Poradnik Kakobuy Spreadsheet
              </Link>
              <Link
                to="/artykul/kakobuy-bezpieczenstwo"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Bezpieczeństwo Kakobuy
              </Link>
              <Link
                to="/artykul/kakobuy-wysylka-polska"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Wysyłka do Polski
              </Link>
              <Link
                to="/artykul/kakobuy-porownanie-agentow"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Porównanie Agentów
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
              >
                Kakobuy Spreadsheet
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            {t("footer.copyright")}
          </p>
          <p className="text-background-600 text-xs max-w-md text-center sm:text-right leading-relaxed">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}